<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-show-modal-staff-signin"
      data-bs-toggle="modal"
      data-bs-target="#modalStaffSignIn"
    ></button>
    <div
      class="modal fade"
      id="modalStaffSignIn"
      tabindex="-1"
      aria-labelledby="modalStaffSignInLabel"
      aria-hidden="true"
    >
      <KskModalShell :width="780" :show-close="false">
        <div class="ksk-staff">
          <div class="ksk-staff__header">
            <div class="ksk-staff__icon">
              <span class="material-icons-round">badge</span>
            </div>
            <div class="ksk-staff__heading">
              <h2 id="modalStaffSignInLabel" class="ksk-staff__title">{{ $t("kiosk.staff.title") }}</h2>
              <p class="ksk-staff__caption">{{ $t("kiosk.staff.caption") }}</p>
            </div>
            <!-- KSK019: keeps the btn-close-modal class — checkStaff() closes the
                 modal with $(".btn-close-modal").click() after a successful login. -->
            <button
              type="button"
              class="btn-close-modal ksk-staff__close"
              :aria-label="$t('kiosk.common.close')"
              data-bs-dismiss="modal"
            >
              <span class="material-icons-round">close</span>
            </button>
          </div>

          <div class="ksk-staff__field">
            <span class="material-icons-round ksk-staff__field-icon">badge</span>
            <input
              ref="realInput"
              type="text"
              v-model="input"
              autocomplete="off"
              inputmode="none"
              class="ksk-staff__input"
              @keydown="onKeyDown"
            />
          </div>

          <!-- Reserved error line: always takes its height so the keyboard never jumps. -->
          <div class="ksk-staff__error" role="alert">
            <template v-if="snackbar === 'danger' && message">
              <span class="material-icons-round">error_outline</span>
              <span>{{ message }}</span>
            </template>
          </div>

          <div class="ksk-staff__keyboard">
            <KskQwertyKeyboard v-model="input" />
          </div>

          <KskButton class="ksk-staff__submit" size="md" block icon-right="arrow_forward" @click="checkStaff()">
            {{ $t("kiosk.header.signIn") }}
          </KskButton>
        </div>
      </KskModalShell>
    </div>
    <material-loading :active="loaderActive" />
  </div>
</template>

<script>
import MaterialLoading from "@/components/MaterialLoading.vue";
import { localStorageName } from "@/config/utils";
import KskQwertyKeyboard from "./ui/KskQwertyKeyboard.vue";
import KskButton from "./ui/KskButton.vue";
import KskModalShell from "./ui/KskModalShell.vue";
import KioskService from "@/services/kiosk.service";
import MemberService from "@/services/member.service";
import $ from "jquery";
import EventBus from "vue3-eventbus";

export default {
  name: "ModalSignInNew",
  components: {
    MaterialLoading,
    KskQwertyKeyboard,
    KskButton,
    KskModalShell,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loaderActive: false,
      message: "",
      snackbar: null,
      merchantCode: "",
      branchCode: "",
      input: "",
      branch: JSON.parse(
        localStorage.getItem(localStorageName("BRANCH_INFO"), "")
      ),
      lastInputTimeout: null,
      showLastChar: false,
      keyboard: null,
      timeoutId: null,
      intervalId: null,
    };
  },
  mounted() {
    this.merchantCode = this.$store.state.merchantCode;
    this.branchCode = this.$store.state.branchCode;
  },
  beforeUnmount() {
    clearTimeout(this.timeoutId);
    clearInterval(this.intervalId);
    this.timeoutId = null;
    this.intervalId = null;
  },
  methods: {
    checkStaff() {
      if (this.input == "") {
        this.snackbar = "danger";
        this.message = this.$t("kiosk.staff.enterCard");
        this.setTimeOutNotification();
        return;
      }

      if (!this.branch || !this.branch.enable_retail_mode || !this.branch.staff_on_retail_mode) {
        this.snackbar = "danger";
        this.message = this.$t("kiosk.staff.notAllowed");
        this.setTimeOutNotification();
        return;
      }

      this.showLoader();
      var dataForm = {
        branch_code: this.branchCode,
        staff_id: this.input,
      };

      KioskService.checkStaff(dataForm, this.merchantCode).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const staff = response.data.data;

            dataForm = {
              phone_number: staff?.phone_number,
              phone_code: staff?.phone_code,
            };

            MemberService.loginPhoneNumber(dataForm, this.merchantCode).then(
              (response) => {
                if (response.result.isSuccess) {
                  $(".btn-close-modal").click();
                  localStorage.setItem(
                    localStorageName("STAFF_INFO"),
                    JSON.stringify(staff)
                  );

                  // KSK110: signed in from the Checkout header, stay on the page.
                  if (this.$route.name === "CheckoutPageKiosk") {
                    EventBus.emit("LoginSuccess");
                    return;
                  }
                  this.$router.push({
                    name: "CheckoutPageKiosk",
                    params: {
                      merchant_code: this.merchantCode,
                      branch_code: this.branchCode,
                    },
                  });
                } else {
                  this.snackbar = "danger";
                  this.message = response.data.result.message;
                  this.setTimeOutNotification();
                }
              }
            );
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response.data.result.message;
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },

    onKeyDown(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.checkStaff();
      }
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
  watch: {
    keyReload() {
      this.input = "";

      // One focus loop at a time: each opening used to add another.
      clearTimeout(this.timeoutId);
      clearInterval(this.intervalId);
      this.timeoutId = setTimeout(() => {
        this.intervalId = setInterval(() => {
          if (this.$refs.realInput) {
            this.$refs.realInput.focus();
          }
        }, 100);
      }, 100);
    },
  },
};
</script>

<style scoped>
/* Sized like the kiosk Promo Code modal (also a full keyboard): 780px,
   40px padding, 32px title, 72px field, 64px keys, 80px button. */
.modal {
  overflow-y: hidden;
}
.modal :deep(.ksk-modal) {
  padding: 40px;
}

.ksk-staff {
  display: flex;
  flex-direction: column;
}

.ksk-staff__header {
  display: flex;
  align-items: center;
  gap: var(--ksk-space-2);
  margin-bottom: var(--ksk-space-3);
}

.ksk-staff__icon {
  flex: none;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--ksk-primary-container);
  color: var(--ksk-primary);
}
.ksk-staff__icon .material-icons-round {
  font-size: 32px;
}

.ksk-staff__heading {
  flex: 1;
  min-width: 0;
}

.ksk-staff__title {
  margin: 0;
  font-family: var(--ksk-font);
  font-size: var(--ksk-title-size);
  line-height: var(--ksk-title-lh);
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ksk-text);
}

.ksk-staff__caption {
  margin: 2px 0 0;
  font-family: var(--ksk-font);
  font-size: 18px;
  line-height: 24px;
  color: var(--ksk-text-secondary);
}

.ksk-staff__close {
  flex: none;
  align-self: flex-start;
  width: 56px;
  height: 56px;
  margin: -8px -8px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: var(--ksk-surface-muted);
  color: var(--ksk-text);
  cursor: pointer;
  transition: transform 80ms ease-out;
}
.ksk-staff__close .material-icons-round {
  font-size: 30px;
}
.ksk-staff__close:active {
  transform: scale(0.97);
}

/* 72px input with a focus ring */
.ksk-staff__field {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 72px;
  padding: 0 var(--ksk-space-3);
  border: 2px solid var(--ksk-border);
  border-radius: var(--ksk-radius-card);
  background: var(--ksk-surface-muted);
  transition: border-color 80ms ease-out, box-shadow 80ms ease-out;
}
.ksk-staff__field:focus-within {
  border-color: var(--ksk-primary);
  box-shadow: 0 0 0 4px var(--ksk-primary-container);
}

.ksk-staff__field-icon {
  flex: none;
  font-size: 30px;
  color: var(--ksk-primary);
}

.ksk-staff__input {
  flex: 1;
  min-width: 0;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-family: var(--ksk-font);
  font-size: 32px;
  line-height: 40px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--ksk-primary);
  caret-color: var(--ksk-primary);
}

.ksk-staff__error {
  display: flex;
  align-items: center;
  gap: var(--ksk-space-1);
  min-height: 36px;
  padding: 6px var(--ksk-space-1) 0;
  font-family: var(--ksk-font);
  font-size: var(--ksk-caption-size);
  line-height: var(--ksk-caption-lh);
  font-weight: 600;
  color: var(--ksk-error);
}
.ksk-staff__error .material-icons-round {
  font-size: 24px;
}

/* Keyboard straight on the card (no extra framed box), compact keys here
   only — the menu search keyboard keeps its size. */
.ksk-staff__keyboard {
  margin-top: var(--ksk-space-1);
}
.ksk-staff__keyboard :deep(.ksk-qwerty),
.ksk-staff__keyboard :deep(.ksk-qwerty__row) {
  gap: 6px;
}
.ksk-staff__keyboard :deep(.ksk-qwerty__key) {
  max-width: calc((100% - 9 * 6px) / 10);
  height: 64px;
  border-radius: 14px;
  font-size: 26px;
  line-height: 32px;
}
.ksk-staff__keyboard :deep(.ksk-qwerty__key--wide),
.ksk-staff__keyboard :deep(.ksk-qwerty__key--space) {
  max-width: none;
}
.ksk-staff__keyboard :deep(.ksk-qwerty__key--action) {
  font-size: 20px;
}
.ksk-staff__keyboard :deep(.ksk-qwerty__key .material-icons-round) {
  font-size: 28px;
}

.ksk-staff__submit {
  margin-top: var(--ksk-space-3);
}
</style>
